import React from "react";
import ConfirmDeletePopUp from "./ConfirmDeletePopUp";
import warningIcon from "../../assets/admin Images/warning-icon.svg";
import { purgeConfirmName } from "../../utils/api/deletion";

/**
 * [INC-1955 §8] Permanently Delete.
 *
 * A plain confirmation, the same pop-up Restore uses. The server still compares
 * `confirmText` against the register row's own name, so the name is sent for the admin
 * instead of making them type it. Callers keep the same props as before.
 */
const PurgeConfirmModal = ({ show, row, onHide, onConfirm, submitting }) => {
  const expected = purgeConfirmName(row);
  if (!show) return null;

  // .delete-box-btn is a fixed 8em x 2.4em box, so "Permanently Delete" wrapped onto two
  // lines and sat taller than every other confirm in the portal. The title and the message
  // above it both already say permanently, and every other red confirm button here is the
  // single word.

  return (
    <ConfirmDeletePopUp
      icon={warningIcon}
      title={"Permanently Delete"}
      Message={
        expected ? (
          <>
            Do you really want to permanently delete {expected}? This cannot be undone.
          </>
        ) : (
          <>This record has no name or company stored, so it cannot be confirmed.</>
        )
      }
      firstButtonName={"Cancel"}
      firstButtonClass={"confirm-white-btn"}
      firstFunction={onHide}
      secondButtonName={submitting ? "Deleting…" : "Delete"}
      secondButtonClass={"confirm-red-btn"}
      secondFunction={() => {
        if (expected && !submitting) onConfirm({ confirmText: expected, note: "" });
      }}
    />
  );
};

export default PurgeConfirmModal;
